import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import moment from "moment-timezone";
import CommonTable from "../common-components/common-tables/CommonTable";
import { formatDateTime } from "../common-data/Converts";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import {
  CallIcon,
  PersonIcon,
} from "../../images/icons/icons";

const TrainersRatingLogs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  allDatas,
  setAllDatas,
  userInfoData,
  callFunction,
}) => {
  const { trainerRatings, trainerRatingsLoading, trainerRatingsError } = useSelector(
    (state) => state.webApi
  );

  const iniClickValues = {
    isModOpen: false,
    cardName: "",
    content: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  useEffect(() => {
    if (
      !trainerRatingsLoading &&
      !trainerRatingsError &&
      trainerRatings?.success &&
      trainerRatings?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: trainerRatings.data,
        pagination:
          trainerRatings?.pagination?.length > 0 ? trainerRatings.pagination : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [trainerRatingsLoading, trainerRatingsError, trainerRatings, setAllDatas]);

  const tbColumns = [
    {
      dataField: "user_name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data" style={{ fontWeight: "600", fontSize: "16px" }}>{row?.user_name || "NA"}</span>
            </div>
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>
              <span className="tb-data">{row?.user_mobile || "NA"}</span>
            </div>
            <div className="tb-flex">
              <span className="tb-data">{row?.user_email || "NA"}</span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.trainer_name || "NA"}</span>;
      },
    },
    {
      dataField: "rating",
      text: "Rating",
      formatter: (_, row) => {
        const rating = parseInt(row?.rating) || 0;
        
        if (rating === 0) {
          return (
            <span className="tb-data" style={{ color: "#6c757d" }}>
              -
            </span>
          );
        }
        
        return (
          <span className="tb-data" style={{ fontWeight: "500" }}>
            {rating}
          </span>
        );
      },
    },
    {
      dataField: "rating_type",
      text: "Rating Type",
      formatter: (_, row) => {
        let typeLabel = "NA";
        if (row?.rating_type === "regular") {
          typeLabel = "Regular Rating";
        } else if (row?.rating_type === "threeday") {
          typeLabel = "Three Day Trial";
        } else if (row?.rating_type === "PTtrial") {
          typeLabel = "PTtrial";
        }
        const typeColor = typeLabel === "Regular Rating" ? "#28a745" : "#007bff";
        const backgroundColor = typeLabel === "Regular Rating" ? "#d4edda" : "#cce7ff";
        
        return (
          <span 
            className="tb-data"
            style={{
              display: "inline-block",
              padding: "4px 12px",
              borderRadius: "9999px",
              backgroundColor: backgroundColor,
              color: typeColor,
              fontWeight: "500",
              fontSize: "12px",
              textTransform: "capitalize",
              border: `1px solid ${typeColor}20`
            }}
          >
            {typeLabel.replace(/_/g, " ")}
          </span>
        );
      },
    },
    {
      dataField: "comment",
      text: "Comment",
      formatter: (_, row) => {
        const comment = row?.comment || "";
        const hasComment = comment && comment.trim() !== "";
        
        if (!hasComment) {
          return (
            <span className="tb-data" style={{ color: "#6c757d" }}>
              -
            </span>
          );
        }

        return (
          <span className="tb-data" style={{ maxWidth: "200px", wordWrap: "break-word" }}>
            <b
              className="tb-link"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "comment",
                  content: comment,
                }))
              }
            >
              Read
            </b>
          </span>
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      formatter: (_, row) => {
        const description = row?.description || "";
        const hasDescription = description && description.trim() !== "";
        
        if (!hasDescription) {
          return (
            <span className="tb-data" style={{ color: "#6c757d" }}>
              -
            </span>
          );
        }

        return (
          <span className="tb-data" style={{ maxWidth: "200px", wordWrap: "break-word" }}>
            <b
              className="tb-link"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "description",
                  content: description,
                }))
              }
            >
              Read
            </b>
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        // date_added is stored as epoch SECONDS (e.g. 1781342047). formatDateTime
        // only accepts ISO-8601, so it returned "-" for these. Convert epoch →
        // readable IST date here; fall back to formatDateTime for ISO strings.
        const raw = row?.date_added;
        let display = "-";
        if (raw !== null && raw !== undefined && `${raw}`.trim() !== "") {
          const num = Number(raw);
          display = !isNaN(num)
            ? moment(num * 1000).tz("Asia/Kolkata").format("DD MMM YYYY hh:mm A")
            : formatDateTime(raw);
        }
        return (
          <div className="tb-flex">
            <span className="tb-data">
              {display}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          <ModalHeadAndClose
            title={clickValues.cardName === "comment" ? "Comment" : "Description"}
            onClose={onCloseModal}
          />

          <div className="discussionModalMessage mt30">
            <p className="message">
              {clickValues.content || "No Content Available"}
            </p>
          </div>
        </div>
      </Modal>

      <div className="common-table-container mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={trainerRatingsLoading}
        />
      </div>
    </>
  );
};

export default TrainersRatingLogs;
